import { render, staticRenderFns } from "./passwordForm.vue?vue&type=template&id=0b2d4ce6&scoped=true"
import script from "./passwordForm.vue?vue&type=script&lang=js"
export * from "./passwordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2d4ce6",
  null
  
)

export default component.exports